import {Markdown} from '../utils/md';

type Gear = {
	id: string;
	title: string;
	count?: number;
};

export function toMonsterGear(gears: Gear[]) {
	return (
		<Markdown
			text={`*Снаряжение* ${gears
				.map((gear) => {
					let result = `{@item ${gear.id}, ${gear.title}}`;
					if (gear.count) result += ` (${gear.count})`;
					return result;
				})
				.join(', ')}`}
		/>
	);
}
